import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { AuthService } from '../../services/auth/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-auth-page-provider',
  templateUrl: './auth-page-provider.component.html',
  styleUrls: ['./auth-page-provider.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthPageProviderComponent implements OnInit {

  
  //  Public
  public coreConfig: any;
  public loginForm: FormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  public passwordTextType: boolean;

  email: string;
  password: string;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _AuthService: AuthService
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }




  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    const loginData = this.loginForm.value;
    let respData: any;

    try {

      this._AuthService.login(loginData).subscribe(
        (res) => {
          respData = res;
          localStorage.setItem('login_token', respData.user.access_token);
          localStorage.setItem('provider_id', respData.user.id);
          localStorage.setItem('user_type', respData.user.type_person);
          localStorage.setItem('type', respData.user.type);
          
          this._router.navigate(['/main/home']);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Bienvenido',
            text: 'Has iniciado sesión correctamente',
            showConfirmButton: false,
            timer: 1000
          })
        },
        (err) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Correo o contraseña incorrectos',
            confirmButtonText: 'Ok'
          })
        }
      )

    } catch (error) {
      console.log("error: ", error);
    }



  }


  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }


  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  registerRouter() {
    this._router.navigate(['/provider-register']);
  }


  loginRouter(){
    this._router.navigate(['/']);
  }

}
